import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { TransferProduct } from '../../ShoppingCartSliceV2';
import { MainProductType } from '../../interfaces';

interface Props {
  product: TransferProduct;
  transfer_type?: string;
  mainProductType?: MainProductType;
}

const ShoppingCartTransfer: React.FC<Props> = ({ product, transfer_type, mainProductType }) => {
  const { shoppingCartTranslations: t } = useSelector(
    (data: RootState) => data.config.translations
  );

  return (
    <div className="package-general-info transfers">
      <b>{t?.transfers}: </b>
      {/* <div className="title">{product?.name}</div> */}
      {/* <p>*{transfer_type == 'reg' ? t?.reg_transfers : t?.shuttle_transfers}</p> */}
      <p>{t?.round_trip_transfers}</p>
    </div>
  );
};

export default ShoppingCartTransfer;
